export default __webpack_public_path__ + "static/media/referralLink.fe7f8d79.svg";